/* eslint-disable quotes */
import { Chip } from '@material-ui/core';
// import Label from '../components/Label';

const paymentMethodsValue = {
  cash: '1',
  check: '2',
  creditCard: '3',
  cari: '4'
};

const constants = {
  role: {
    buyer: 1,
    seller: 2,
  },
  creatableType: {
    product: 'product',
    productGroup: 'productGroup',
    brand: 'brand',
  },
  requestType: {
    post: 'POST',
    get: 'GET',
    delete: 'DELETE',
  },
  measurementUnit: [
    { value: 1, label: 'Adet', title: 'Adet' },
    { value: 2, label: 'KG', title: 'kilogram' },
    { value: 3, label: 'm³', title: 'metreküp' },
    { value: 4, label: 'Litre', title: 'litre' },
    { value: 5, label: 'Metre', title: 'metre' }
  ],
  paymentMethods: [
    { value: paymentMethodsValue.cash, label: 'Nakit', key: 'cash' },
    { value: paymentMethodsValue.check, label: 'Çek', key: 'check' },
    { value: paymentMethodsValue.creditCard, label: 'Kredi Kartı', key: 'creditCard' },
    { value: paymentMethodsValue.cari, label: 'Cari Hesap', key: 'cari' }
  ],
  bidRequestStatus: {
    1: 'OPEN',
    2: 'CLOSEDBYCUSTOMER',
    3: 'MATCHED',
    4: 'TIMESUP'
  },
  bidResponseStatusValue: {
    ACTIVE: 1,
    CANCELLED: 2,
  },
  bidRequestStatusValue: {
    OPEN: 1,
    CLOSEDBYCUSTOMER: 2,
    MATCHED: 3,
    TIMESUP: 4,
  },
  bidRequestStatusLabel: (status) => {
    // if (!status) {
    //   return '-';
    // }
    try {
      const map = {
        1: {
          color: 'success',
          text: 'Açık'
        },
        2: {
          color: 'warning',
          text: 'İptal'
        },
        3: {
          color: 'error',
          text: 'Sipariş'
        },
        4: {
          color: 'info',
          text: 'Süresi doldu'
        },
        5: {
          color: 'warning',
          text: 'Onay bekliyor'
        }
      };
      const { text = 'Bilinmeyen', color = 'error' } = map[status];
      return (
        <Chip
          color={color}
          size="small"
          label={text}
        />
      );
    } catch (error) {
      return '-';
    }
  },
  bidPreRequestStatus: {
    1: {
      color: 'success',
      text: 'Talep Aşamasında'
    },
    2: {
      color: 'warning',
      text: 'Fiyat Teklifi Toplanıyor'
    },
    3: {
      color: 'error',
      text: 'İhale İptal Edildi'
    },
    4: {
      color: 'info',
      text: 'Teklifler Değerlendiriliyor'
    },
    5: {
      color: 'warning',
      text: 'Sipariş Oluşturuldu'
    },
    6: {
      color: 'warning',
      text: 'Sipariş Tamamlandı'
    },
    7: {
      color: 'warning',
      text: 'Taslak/Ön Talep İptal Edildi'
    },
    8: {
      color: 'warning',
      text: 'Ön Talep Sorumlusu İptal'
    },
    9: {
      color: 'warning',
      text: 'Satın Alma Sorumlusu İptal '
    },
    10: {
      color: 'warning',
      text: 'Ön Talep Sorumlusu İptal '
    },
  },
  bidPreRequestStatusLabel: (status) => {
    try {
      const map = constants.bidPreRequestStatus;
      const { text = 'Bilinmeyen', color = 'error' } = map[status];
      return (
        <Chip
          color={color}
          size="small"
          label={text}
          className="tp-on-talep__table-badge"
        />
      );
    } catch (error) {
      return '-';
    }
  },
  orderStatusValue: {
    ACTIVE: 1,
    COMPLATED: 2,
    CANCELLED: 3,
  },
  orderStatusLabel: (status) => {
    try {
      const map = {
        0: {
          color: 'info',
          text: 'Bekleyen Sipariş'
        },
        1: {
          color: 'success',
          text: 'Aktif Sipariş'
        },
        2: {
          color: 'error',
          text: 'Tamamlanmış Sipariş'
        },
        3: {
          color: 'warning',
          text: 'İptal Sipariş'
        },
      };
      const { text = 'Bilinmeyen', color = 'info' } = map[status];
      return (
        <Chip
          color={color}
          size="small"
          label={text}
        />
      );
    } catch (error) {
      return '-';
    }
  },

  userReferenceStatusLabel: (status) => {
    const map = {
      0: {
        color: 'warning',
        text: 'Beklemede'
      },
      1: {
        color: 'success',
        text: 'Kabul Edildi'
      },
      2: {
        color: 'error',
        text: 'Reddedildi'
      },
    };
    const { text = 'Bilinmeyen', color = 'error' } = map[status];
    return (
      <Chip
        color={color}
        size="small"
        label={text}
      />
    );
  },

  userStatus: {
    PASSIVE: 0, // email onayı yapmamış sistemi hiç giremez
    ACTIVE: 1, // email onaylanmış , adminden yetki alamamış ihale ve teklif yapamaz
    CLOSED: 2, // admin kapatmış
    APPROVED: 3, // eMAİL VE VKN onaylı. ihale ve teklif açabilir.
  },
  userStatusValues: {
    0: 'Pasif',
    1: 'Aktif',
    2: 'Kapatılmış',
    3: 'Onaylanmış',
  },
  currencies: [
    {
      value: 'TRY',
      label: '₺',
    },
    {
      value: 'USD',
      label: '$',
    },
    {
      value: 'EUR',
      label: '€',
    },
    // {
    //   value: 'GBP',
    //   label: '£',
    // }
  ],
  currencySymbol: {
    USD: '$',
    TRY: '₺',
    EUR: '€',
    // GBP: '£',
    USDTRY: 'USD',
    EURTRY: 'EUR',
    // GBPTRY: 'GBP/TRY',
  },
  paymentMethodsValue,
  defaultCurrency: 'TRY',
  defaultCulture: 'Tr',
  responsableStatus: {
    OK: 1,
    ALREADYOFFERED: 2,
    HAVEBLACKLIST: 3
  },
  userReferenceStatus: {
    WAITING: 0,
    ACCEPTED: 1,
    REJECTED: 2,
  },
  notificationType: {
    DEPOSIT: 'DEPOSIT',
    NEW_BID_RESPONSE: 'NEW_BID_RESPONSE',
    NEW_BID_MATCH: 'NEW_BID_MATCH',
    NEW_MESSAGE: 'NEW_MESSAGE',
    NEW_BID_MATCH_RATE: 'NEW_BID_MATCH_RATE',
    NEW_REFERENCE_REQUEST: 'NEW_REFERENCE_REQUEST',
    APPROVE_REFERENCE: 'APPROVE_REFERENCE',
    BID_ENDING_ANNOUNCEMENT: 'BID_ENDING_ANNOUNCEMENT',
    CANCEL_BID_RESPONSE: 'CANCEL_BID_RESPONSE',
    CANCEL_BID_REQUEST: 'CANCEL_BID_REQUEST',
  },
  userType: {
    legal: 'Tüzel',
    real: 'Gerçek'
  },
  notificationUserType: {
    buyer: 'Buyer',
    seller: 'Seller',
    both: 'Both'
  },
  filterType: {
    quantity: 'quantity',
    deliveryTime: 'deliveryTime',
    responseDate: 'responseDate', // Teklif tatihi
    bidRequestDate: 'bidRequestDate', // Oluşturulma tarihi
    insertDate: 'insertDate', // PaymentBilling
    product: 'productId',
    brand: 'brand',
    depositType: 'provider',
    productGroup: 'productGroupList',
    bidDetail: 'bidDetail',
    activityArea: 'activityArea',
  },
  chatStatus: {
    active: 1,
    passive: 2
  },
  checkboxFilterModel: {
    getFavCompany: 'getFavCompany',
    getHiddenBids: 'getHiddenBids',
    getFavCompanyBids: 'getFavCompanyBids',
    getMyFavCompany: 'getMyFavCompany',
    getDiscardBid: 'getDiscardBid',
    getWatchedBid: 'getWatchedBid',
    getAllBidRequests: 'getAllBidRequests',
  },
  urgencyOptions: [
    {
      value: 'low',
      title: 'Düşük',
    },
    {
      value: 'medium',
      title: 'Orta',
    },
    {
      value: 'high',
      title: 'Yüksek'
    },
  ],
  urgencyMap: {
    low: 'Düşük',
    medium: 'Orta',
    high: 'Yüksek',
  },
};

export default constants;

export const tenderFinishValue = [
  { value: 3, label: '3' },
  { value: 12, label: '12' },
  { value: 24, label: '24' },
  { value: 36, label: '36' },
  { value: 48, label: '48' },
  { value: 60, label: '60' },
  { value: 72, label: '72' }
];

export const activityAreaUsingType = {
  buy: {
    name: 'buy',
    label: 'Alıcı - Müşteri Firma ( Platformu Sadece Firmamızın Satınalma Talepleri Oluşturmak İçin Kullanıyorum )',
    shortLabel: 'Alıcı - Müşteri Firma',
  },
  sell: {
    name: 'sell',
    label: 'Tedarikçi - Satıcı Firma (Platformdaki tedarikçi arama kısımlarında listelenmek için bu seçeneği işaretleyin)',
    shortLabel: 'Tedarikçi - Satıcı Firma',
  },
  both: {
    name: 'both',
    label: 'Hem Alıcı ve Hem Tedarikci Firma ( Platformu firmamızın Satınalma Taleplerini oluşturmak için ve diğer firmaların Satınalma Taleplerine teklif vermek için kullanıyorum',
    shortLabel: 'Hem Alıcı ve Hem Tedarikci Firma',
  },
};

export const commentTypes = {
  incoming: 1,
  my: 2,
};

export const initialOrderOptions = {
  paymentMethod: '1',
  cariExpiry: null,
  checkExpiry: null,
  brand: '',
  deliveryTime: null,
  addressId: null,
  showFavoriteGroup: false,
  tenderFinishValue: 24,
  bidRequestGroupId: null,
  hideName: false,
  hideBestBid: false,
  enableFile: false,
  files: null,
  onlyFavSellers: false,
  getOffersFromAllSupplier: true,
  favSellerGroupId: [],
  informFavSellerGroupId: [],
  links: [],
  plannedOpeningDate: null,
  companySelectionType: 'favorite',
  selectedPopularSupplierCompanyIds: [],
};
export const initialOrderProduct = {
  productDetail: '',
  quantity: '',
  measurementUnit: '',
  showSpesificFilter: false,
  options: {
    ...initialOrderOptions
  },
};

export const exampleOrderJson = {
  productDetail: 'XYZ ürünü - ürün kodu- kısa açıklama',
  quantity: '100',
  measurementUnit: 'adet',
  paymentMethod: 'nakit',
  brand: 'XYZ',
  deliveryTime: new Date(new Date().getTime() + 10 * 24 * 60 * 60 * 1000).toLocaleDateString('tr-TR').replace(/\./g, '/'),
  tenderFinishValue: 36,
  cariExpiry: null,
  checkExpiry: null,
};

export const orderNameMapping = {
  productDetail: 'Ürün/Hizmet Detayı',
  quantity: 'Miktar',
  measurementUnit: 'Ölçü Birimi',
  paymentMethod: 'Ödeme Türü',
  brand: 'Marka',
  deliveryTime: "Termin Süresi",
  tenderFinishValue: 'İhale Süresi(Saat)',
  cariExpiry: 'Cari Vadesi',
  checkExpiry: 'Çek Vadesi',
};

export const excelParseModel = {
  productDetail: {
    nullable: false,
    type: 'string',
    parser: (value) => value
  },
  quantity: {
    nullable: false,
    type: 'number',
    parser: (value) => {
      try {
        const quantity = parseInt(value, 10);
        return quantity;
      } catch {
        throw new Error('Hatalı miktar değeri');
      }
    },
  },
  measurementUnit: {
    nullable: false,
    type: 'string',
    parser: (value) => {
      const measurementUnit = constants.measurementUnit.find((unit) => value && (value.toLocaleLowerCase() === unit.title.toLocaleLowerCase() || value.toLocaleLowerCase() === unit.label.toLocaleLowerCase()));
      if (!measurementUnit) {
        throw Error('Hatalı ölçü birimi');
      }
      return measurementUnit.label;
    },
  },
  // paymentMethod: {
  //   nullable: true,
  //   type: 'string',
  //   parser: (value) => {
  //     const paymentMethod = constants.paymentMethods.find((method) => value && value.toLocaleLowerCase() === method.label.toLocaleLowerCase());
  //     if (!paymentMethod) {
  //       throw Error('Hatalı ödeme yöntemi');
  //     }
  //     return paymentMethod.value;
  //   },
  // },
  brand: {
    nullable: true,
    type: 'string',
    parser: (value) => value,
  },
  deliveryTime: {
    nullable: true,
    type: 'date',
    parser: (value) => {
      try {
        if (typeof value === 'number') {
          const date = new Date((value - 25569) * 86400000);
          return date;
        } if (typeof value === 'string') {
          const [day, month, year] = value.split('/');
          const monthIndex = parseInt(month, 10) - 1;
          const dateValue = new Date(year, monthIndex, day);
          if (Number.isNaN(dateValue.getTime())) {
            throw new Error('Hatalı tarih değeri. Tarih formatı (GG/AA/YYYY) olmalı');
          }

          return dateValue;
        }
        return 'Tarih algılanmadı!';
      } catch {
        throw new Error('Hatalı tarih değeri. Tarih formatı (GG/AA/YYYY) olmalı');
      }
    },
  },
  // tenderFinishValue: {
  //   nullable: true,
  //   type: 'number',
  //   parser: (value) => {
  //     try {
  //       if (!value) {
  //         return value;
  //       }
  //       const tenderFinishValue = parseInt(value, 10);
  //       if (!Number.isInteger(tenderFinishValue)) {
  //         throw new Error('Hatalı ihale süresi değeri');
  //       }
  //       return tenderFinishValue;
  //     } catch {
  //       throw new Error('Hatalı ihale süresi değeri');
  //     }
  //   },
  // },
  // cariExpiry: null,
  // checkExpiry: null,
};

export const initialPreDemandOptions = {
  brand: '',
  deliveryTime: null,
  enableFile: false,
  files: null,
  links: [],
  note: '',
  buyerUserId: null,
  paymentMethod: "",
  cariExpiry: null,
  checkExpiry: null,
  addressId: null,
  showFavoriteGroup: false,
  tenderFinishValue: null,
  bidRequestGroupId: null,
  hideName: false,
  hideBestBid: false,
  onlyFavSellers: false,
  getOffersFromAllSupplier: true,
  favSellerGroupId: [],
  informFavSellerGroupId: [],
  plannedOpeningDate: null,
};

export const initialPreDemandProduct = {
  productDetail: '',
  quantity: '',
  measurementUnit: '',
  urgency: constants.urgencyOptions[0].value,
  showSpesificFilter: false,
  options: {
    ...initialPreDemandOptions
  },
};

export const departments = [
  {
    label: 'Yönetici - Patron - Şirket Yetkilisi',
    value: 1,
  },
  // {
  //   label: 'Satın Alma Yöneticisi',
  //   value: 2,
  // },
  {
    label: 'Satın Alma Sorumlusu',
    value: 3,
  },
  {
    label: 'Depo Sorumlusu',
    value: 4,
  },
  {
    label: 'Ön Talep Planlama Departmanı',
    value: 5,
  },
  {
    label: 'Diğer',
    value: 6
  },
];

export const userDepartments = {
  1: 'Yönetici veya Şirket Yetkilisi',
  3: 'Satın Alma Yetkilisi',
  4: 'Depo Sorumlusu',
  5: 'Ön Talep Planlama Departmanı',
  6: 'Diğer',
};

export const bidRequestOrderStatus = {
  completed: 2,
  canceled: 3
};
